import { useNavigate, useLocation } from 'react-router-dom';

interface NavigationProps {
  adminUser: {
    displayName: string;
    email: string;
  } | null;
}

export default function Navigation({ adminUser }: NavigationProps) {
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = (path: string) => {
    return location.pathname === path || location.pathname.startsWith(path + '/');
  };

  const navLinkStyle = (path: string) => ({
    padding: '8px 16px',
    borderRadius: '6px',
    fontSize: '14px',
    fontWeight: '500',
    cursor: 'pointer',
    transition: 'all 0.2s',
    background: isActive(path) ? '#3b82f6' : 'transparent',
    color: isActive(path) ? 'white' : '#6b7280',
  });

  const handleLogout = async () => {
    const apiUrl = import.meta.env.VITE_API_URL || 'https://admin.sign.virtue.dk';
    await fetch(`${apiUrl}/api/auth/logout`, {
      method: 'POST',
      credentials: 'include',
    });
    navigate('/login');
  };

  return (
    <nav style={{
      background: 'white',
      borderBottom: '1px solid #e5e7eb',
      padding: '0 32px',
      position: 'sticky',
      top: 0,
      zIndex: 1000,
      boxShadow: '0 1px 2px rgba(0,0,0,0.05)',
    }}>
      <div style={{
        maxWidth: '1400px',
        margin: '0 auto',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        height: '64px',
      }}>
        {/* Logo/Brand */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '32px' }}>
          <div 
            onClick={() => navigate('/dashboard')}
            style={{ 
              fontSize: '18px', 
              fontWeight: '700', 
              color: '#111827',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
            }}
          >
            🛡️ VirtueSign Admin
          </div>

          {/* Navigation Links */}
          <div style={{ display: 'flex', gap: '4px' }}>
            <div
              onClick={() => navigate('/dashboard')}
              style={navLinkStyle('/dashboard')}
              onMouseEnter={(e) => {
                if (!isActive('/dashboard')) {
                  e.currentTarget.style.background = '#f3f4f6';
                }
              }}
              onMouseLeave={(e) => {
                if (!isActive('/dashboard')) {
                  e.currentTarget.style.background = 'transparent';
                }
              }}
            >
              Dashboard
            </div>
            <div
              onClick={() => navigate('/tenants')}
              style={navLinkStyle('/tenants')}
              onMouseEnter={(e) => {
                if (!isActive('/tenants')) {
                  e.currentTarget.style.background = '#f3f4f6';
                }
              }}
              onMouseLeave={(e) => {
                if (!isActive('/tenants')) {
                  e.currentTarget.style.background = 'transparent';
                }
              }}
            >
              Tenants
            </div>
            <div
              onClick={() => navigate('/billing')}
              style={navLinkStyle('/billing')}
              onMouseEnter={(e) => {
                if (!isActive('/billing')) {
                  e.currentTarget.style.background = '#f3f4f6';
                }
              }}
              onMouseLeave={(e) => {
                if (!isActive('/billing')) {
                  e.currentTarget.style.background = 'transparent';
                }
              }}
            >
              Billing
            </div>
            <div
              onClick={() => navigate('/system')}
              style={navLinkStyle('/system')}
              onMouseEnter={(e) => {
                if (!isActive('/system')) {
                  e.currentTarget.style.background = '#f3f4f6';
                }
              }}
              onMouseLeave={(e) => {
                if (!isActive('/system')) {
                  e.currentTarget.style.background = 'transparent';
                }
              }}
            >
              System
            </div>
            <div
              onClick={() => navigate('/audit-logs')}
              style={navLinkStyle('/audit-logs')}
              onMouseEnter={(e) => {
                if (!isActive('/audit-logs')) {
                  e.currentTarget.style.background = '#f3f4f6';
                }
              }}
              onMouseLeave={(e) => {
                if (!isActive('/audit-logs')) {
                  e.currentTarget.style.background = 'transparent';
                }
              }}
            >
              Audit Logs
            </div>
            <div
              onClick={() => navigate('/admin-users')}
              style={navLinkStyle('/admin-users')}
              onMouseEnter={(e) => {
                if (!isActive('/admin-users')) {
                  e.currentTarget.style.background = '#f3f4f6';
                }
              }}
              onMouseLeave={(e) => {
                if (!isActive('/admin-users')) {
                  e.currentTarget.style.background = 'transparent';
                }
              }}
            >
              Admin Users
            </div>
          </div>
        </div>

        {/* User Menu */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
          <div style={{ textAlign: 'right' }}>
            <div style={{ fontSize: '14px', fontWeight: '500', color: '#111827' }}>
              {adminUser?.displayName}
            </div>
            <div style={{ fontSize: '12px', color: '#6b7280' }}>
              {adminUser?.email}
            </div>
          </div>
          <button
            onClick={handleLogout}
            style={{
              padding: '8px 16px',
              background: '#f3f4f6',
              border: 'none',
              borderRadius: '6px',
              fontSize: '14px',
              fontWeight: '500',
              color: '#374151',
              cursor: 'pointer',
              transition: 'background 0.2s',
            }}
            onMouseEnter={(e) => (e.currentTarget.style.background = '#e5e7eb')}
            onMouseLeave={(e) => (e.currentTarget.style.background = '#f3f4f6')}
          >
            Logout
          </button>
        </div>
      </div>
    </nav>
  );
}
